module.exports = {
    controller: htsAppendicesPageController,
    templateUrl: 'us/components/hts-appendices-page.html',
};

htsAppendicesPageController.$inject = [
    '$analytics',
    '$location',
    'notificationsService'
];

function htsAppendicesPageController(
    $analytics,
    $location,
    notifications
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
    };
    return vm;

    function attached() {
        $analytics.pageTrack('/hts-appendices');
        notifications.subscribe('filter_movement_changed', movementChanged)
    }

    function detached() {
        notifications.unsubscribe('filter_movement_changed', movementChanged);
    }

    function movementChanged(movement) {
        if (movement === 'export') {
            $location.path('/schedule-b-general-notes');
        }
    }
}